import React from "react";
import { Popover } from "@mui/material";
import { useDispatch } from "react-redux";
import { ContentCopyOutlined as CopyIcon } from "@mui/icons-material";
import { showSnackbar } from "store/actions/Utility";

function HelpPopover({
  id,
  open,
  anchorEl,
  onClose,
  email = "finance@edgeonline.co",
  heading = "Need help?",
  description = "Email us at",
  className = "popover-wrapper",
}) {
  const dispatch = useDispatch();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(email);
    onClose();
    dispatch(showSnackbar({ dispatch, type: "success", message: "Email address copied" }));
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      className={className}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <div className="popover-container">
        <div className="payment-popover-heading">{heading}</div>
        <div className="payment-popover-desc mt-1">{description}</div>

        <div
          role="button"
          tabIndex={0}
          className="payment-contact-email-wrapper cursor-pointer"
          onClick={copyToClipboard}
          onKeyPress={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              copyToClipboard();
            }
          }}
        >
          <div className="payment-contact-email">{email}</div>
          <CopyIcon className="copy-icon" />
        </div>
      </div>
    </Popover>
  );
}

export default HelpPopover;
